import { useQuery } from '@tanstack/react-query';
import { summaryHasActiveTasks } from '../../components/BackgroundTasksWidget/utils';
import { RepositoryClient } from '../httpClients/RepositoryClient';
import { QUERY_KEYS } from './consts';

export const SUMMARY_STALE_TIME_MS = 15_000;
/** Poll cadence while any task is pending or in progress. */
export const SUMMARY_ACTIVE_POLL_MS = 30_000;
/** Slow ambient poll while idle, so work started later is still discovered. */
export const SUMMARY_IDLE_POLL_MS = 120_000;

/**
 * Workspace-wide background-task status counts, grouped by task type.
 * Polls every {@link SUMMARY_ACTIVE_POLL_MS} while anything is running,
 * drops to {@link SUMMARY_IDLE_POLL_MS} when idle (new work discovery), and
 * stops entirely once the query errors — a 4xx (endpoint not deployed on
 * older backends) is terminal and callers render nothing on error.
 *
 * @returns The TanStack query result for the tasks summary.
 */
export const useTaskTrackerSummaryQuery = ({ enabled = true } = {}) =>
  useQuery({
    queryKey: [QUERY_KEYS.TASK_TRACKER_SUMMARY],
    queryFn: RepositoryClient.getTaskTrackerSummary,
    enabled,
    staleTime: SUMMARY_STALE_TIME_MS,
    retry: false,
    refetchInterval: (query) => {
      if (query.state.status === 'error') return false;

      return summaryHasActiveTasks(query.state.data)
        ? SUMMARY_ACTIVE_POLL_MS
        : SUMMARY_IDLE_POLL_MS;
    },
  });
